var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:("" + (this.theme.dark ? '' : this.theme.color)),attrs:{"tile":"","flat":""}},[_c('v-card-title',{attrs:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }